import { Component } from '@angular/core';
import { Lifecycle } from '../../../../_helpers/Lifecycle/Lifecycle.class';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { $BroadcastManagerService } from '../../../../_helpers/BroadcastManager.service';

@Component({
  selector: 'app-dashboard-root',
  templateUrl: './dashboard-root.component.html',
  styleUrls: ['./dashboard-root.component.css']
})
export class DashboardRootComponent extends Lifecycle {

  constructor(
    private db: $DBManagerService,
    private evt: $BroadcastManagerService
  ) {
    super();
    this.evt.emit({ 'click': 'HEADER_EVENT' });
  }

  _initialize(): void {

  }

  _destroy(): void {
    // throw new Error("Method not implemented.");
  }

}
